import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ✅ detecta Google Tradutor e recarrega a página antes de quebrar o React
const observer = new MutationObserver(() => {
  const html = document.documentElement;
  if (
    html.classList.contains('translated-ltr') ||
    html.classList.contains('translated-rtl')
  ) {
    observer.disconnect();
    window.location.reload();
  }
});

observer.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['class']
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.unregister();

reportWebVitals();